<nav class="navbar navbar-light bg-light navbar-expand-lg">
  <div class="collapse navbar-collapse" id="navbarSupportedContent">
    <ul class="navbar-nav me-auto">
      <li class="nav-item float-end me-2">
        <button type="button" class="btn btn-outline-primary my-2 my-lg-0 mx-lg-2" (click)="nuevoNivel()"> Nuevo Nivel </button>
      </li>
      <li class="nav-item float-end me-2">
          <button type="button" class="btn btn-outline-primary my-2 my-lg-0 mx-lg-2" (click)="editarNivel()" [disabled]="!this.nivelSeleccionado"> Editar Nivel </button>
      </li>
      <li class="nav-item float-end me-2">
          <button type="button" class="btn btn-outline-primary my-2 my-lg-0 mx-lg-2" [disabled]="!this.horaBloqueo" (click)="cambiarHoraBloqueoCuentas()"> Hora de bloqueo de cuentas </button>
      </li>
    </ul>
    <ul class="navbar-nav ms-auto">
      <li class="nav-item float-end me-2">
          <button type="button" class="btn btn-outline-primary my-2 my-lg-0 mx-lg-2" [disabled]="!this.nivelSeleccionado" (click)="agregarUsuarios()"> Agregar usuario </button>
      </li>
      <li class="nav-item float-end me-2">
          <button type="button" class="btn btn-outline-primary my-2 my-lg-0 mx-lg-2" [disabled]="!this.nivelSeleccionado" (click)="agregarDelegaciones()"> Agregar delegación </button>
      </li>
    </ul>
  </div>
</nav>

<div class="row">
  <div class="col col-3">
    <ngb-alert type="warning" [dismissible]="false" class="alert alert-warning" 
      *ngIf="!cargandoLista && this.niveles?.length == 0">
      No se obtuvieron niveles para Control de Crédito
    </ngb-alert>

    <div class="list-group py-3 menu-izq">
      <ng-container *ngIf="cargandoLista">
        <div class="col col-md-12">
          <div class="spinner-container">
            <ngx-spinner name="spinnerGrafico" bdOpacity=0.3bd Color="rgba(193,193,193,0)" size="medium" color="#185db5"
              type="ball-grid-beat" [fullScreen]="false">
              <p style="color: white">C a r g a n d o . . . </p>
            </ngx-spinner>
          </div>
        </div>
      </ng-container>
      <div *ngIf="!cargandoLista">
        @for (nivel of niveles; let i = $index; track $index) {
        <button type="button" class="list-group-item list-group-item-action"
          (click)="seleccionarNivel(i)">
          <div class="d-flex w-100 justify-content-between">
            <p> {{ nivel.nombreNivel }} </p>
          </div>
        </button>
        }
      </div>
    </div>
  </div>

  <div class="col col-9 py-3">
    <div *ngIf="this.nivelSeleccionado" id="tablaNiveles">
      <app-niveles-detalle [nivelSeleccionado]="this.nivelSeleccionado" (updateUsuarios)="actualizarUsuarios($event)"></app-niveles-detalle>
    </div>
  </div>
</div>